import { MessageCircle } from "lucide-react";
import { useLang, WHATSAPP_URL } from "@/lib/i18n";
import Logo, { LogoMark } from "./Logo";

export function WhatsAppFloat() {
  const { t } = useLang();
  return (
    <motion-a
      href={`${WHATSAPP_URL}?text=${encodeURIComponent(t.booking.whatsappMsg)}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
      className="fixed bottom-5 right-5 z-40 grid h-13 w-13 place-items-center rounded-full bg-[#1fa855] text-white shadow-xl shadow-ink/20 transition-transform duration-300 hover:scale-110 md:bottom-8 md:right-8"
    >
      <MessageCircle className="h-6 w-6" />
    </motion-a>
  );
}

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-line bg-sand2 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-ink2">{t.footer.tag}</p>
          </div>

          <div className="text-sm leading-relaxed text-ink2">
            <p className="font-medium text-ink">Private Oasis Villa</p>
            <p className="mt-2">{t.location.address}</p>
            <a href="tel:+393801466883" data-testid="footer-phone" className="mt-1 block hover:text-terra transition-colors duration-300">
              +39 380 146 6883
            </a>
          </div>

          <a
            href={`${WHATSAPP_URL}?text=${encodeURIComponent(t.booking.whatsappMsg)}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp"
            className="flex w-fit items-center gap-2 rounded-full border border-ink/20 px-5 py-2.5 text-[12px] font-semibold uppercase tracking-[0.18em] text-ink transition-all duration-300 hover:bg-ink hover:text-sand"
          >
            <MessageCircle className="h-4 w-4" />
            WhatsApp
          </a>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-line pt-6 text-xs text-ink2 md:flex-row md:items-center md:justify-between">
          <p className="flex items-center gap-2 text-xs text-ink2">
            <LogoMark className="h-5 w-5" />
            © {year} Private Oasis Villa · {t.footer.rights}
          </p>
          <div className="flex items-center gap-5">
            <a
              href="/admin"
              data-testid="footer-admin"
              className="transition-colors duration-300 hover:text-terra"
            >
              Area proprietario
            </a>
            <p className="font-serif text-base italic text-olive">
              Un'oasi di quiete in Sicilia
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
